import styled from '@emotion/styled';

import { Button as StandardButton } from '~/src/components/buttons';
import { breakpoints } from '~/styles';

export const ButtonWrapper = styled.div`
  ${breakpoints.minMobileLandscape} {
    display: flex;
    justify-content: center;
  }
  ${breakpoints.minTablet} {
    justify-content: start;
  }
`;
export const Button = styled(StandardButton)`
  width: 100%;
  border-radius: 4px !important;
  margin: 8px 0 !important;
  ${breakpoints.minMobileLandscape} {
    width: 235px !important;
  }
`;
